/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import Vue from 'vue'
import App from './App.vue'
import config from './config'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'

import AcronisUiKit from '@uikit/ui-kit';
import svgSpritePath from '@uikit/ui-syntax/dist/svg-sprite/symbol/svg/sprite.symbol.svg';
import './assets/styles/index.scss';

//Plugins
import './plugins/moment';

import initRoutes from './router/routes'

Vue.use(AcronisUiKit, { svgSpritePath });

Vue.prototype.$app = config
if (process.env.NODE_ENV === 'production') {
  Vue.config.devtools = false
} else {
  Vue.config.productionTip = false
}
console.log(process.env.NODE_ENV, Vue.config);

initRoutes()

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
